import React from "react";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./page/Home/home";
import Profile from "./page/Profile/profile";

import { Toaster } from "react-hot-toast";
import Navigation from "./component/Navigation";
import DetailEvent from "./page/Checkout/detailEvent";
import TicketEvent from "./page/Checkout/ticketEvent";
import PaymentMethod from "./page/Checkout/paymentMethod";
import NotFound from "./page/NotFound/notfound";
import { AppProvider } from "./hook/AppContext";
import Login from "./page/Auth/login";
import secureLocalStorage from "react-secure-storage";
import Voucher from "./page/Voucher/voucher";

function App() {
  const token = secureLocalStorage.getItem("tokenPartner");
  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        {token === undefined || token === null ? (
          <Route
            path="/"
            element={
              <>
                <Login />
              </>
            }
          />
        ) : (
          <>
            <Route
              path="/"
              element={
                <>
                  <Navigation />
                  <Home />
                </>
              }
            />
            <Route
              path="/report"
              element={
                <>
                  <Navigation />
                  <Profile />
                </>
              }
            />
            <Route
              path="/voucher"
              element={
                <>
                  <Navigation />
                  <Voucher />
                </>
              }
            />
            <Route
              path="/event/:slug"
              element={
                <AppProvider>
                  <DetailEvent />
                </AppProvider>
              }
            />
            <Route
              path="/ticket/:slug"
              element={
                <AppProvider>
                  <TicketEvent />
                </AppProvider>
              }
            />
            <Route
              path="/payment/:slug"
              element={
                <AppProvider>
                  <PaymentMethod />
                </AppProvider>
              }
            />
          </>
        )}

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
